import React from 'react';
import getBrowserFingerprint from 'get-browser-fingerprint';
import { usePostHog } from 'posthog-js/react';

const useUserIdentifier = (): number|null => {
    const [user, setUser] = React.useState<number|null>(null);
    const posthog = usePostHog();

    React.useEffect(() => {
        const probableUser = getBrowserFingerprint({ enableScreen: true });
        if (probableUser) {
            posthog.onSessionId((e) => {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-expect-error
                window.posthog_session_id = e;
            });
            setUser(
                probableUser as number,
            );
            posthog.identify(probableUser);
            try {
                const invocaLocalStorageId = localStorage.getItem('invoca_id');
                if (invocaLocalStorageId) {
                    posthog.alias(invocaLocalStorageId, probableUser);
                }
            } catch (e) {
                // No-op
            }
        }
    }, [posthog]);

    return user;
};

export default useUserIdentifier;
